import { jwtDecode } from 'jwt-decode';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';
import { type Maybe } from '@bbkAdminUtils/utility-types';

export class JWTParser {
  public static parse<T>(jwt: string): Maybe<T> {
    try {
      return jwtDecode<T>(jwt);
    } catch (err) {
      GlobalLogger.error(jwt);
      GlobalLogger.error(err);
      return undefined;
    }
  }
}
